import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { HighlightText, getMouseDistance, lerp } from './utilities.js'

gsap.registerPlugin(ScrollTrigger)

export const introduction = () => {
  let playOnce = true
  const el = document.querySelector('.introduction')
  const heading = el?.querySelector('.introduction__heading')

  if (!el) return

  document.fonts.ready.then(() => {
    const italicAnimation = new HighlightText(heading.querySelector('em'))

    pinAndScaleHeading()
    parallaxEnd()

    function pinAndScaleHeading() {
      const innerText = heading.querySelector('span')
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: el,
          start: 'top 50%',
          endTrigger: heading,
          end: 'top 30%',
          scrub: 1
        }
      })
      tl.fromTo(
        innerText,
        {
          scale: window.innerWidth < 650 ? 1 : 4,
          color: window.innerWidth < 650 ? '#ffffff' : 'transparent'
        },
        {
          scale: 1,
          color: '#ffffff'
        }
      )
      tl.add(() => {
        if (playOnce) {
          animateContent()
          italicAnimation.play()
        }
        playOnce = false
      }, '-=0.1')
    }

    function animateContent() {
      const words = el.querySelectorAll('.introduction__text .word')
      const logos = el.querySelectorAll('.introduction__bar')
      const tl = gsap.timeline()
      tl.to(words, {
        duration: 1.2,
        y: 0,
        x: 0,
        stagger: 0.04,
        rotate: '0deg',
        ease: 'power3.inOut'
      })
      tl.to(
        logos,
        {
          y: 0,
          duration: 1,
          opacity: 1,
          ease: 'power2.inOut'
        },
        '-=1'
      )
    }

    function parallaxEnd() {
      if (window.innerWidth < 650) return
      const container = el.querySelector('.container')
      const heading = el.querySelector('.introduction__heading-wrap')
      gsap.to([container, heading], {
        y: 500,
        opacity: 0,
        ease: 'none',
        scrollTrigger: {
          trigger: el,
          start: 'bottom bottom',
          end: 'bottom top',
          invalidateOnRefresh: true,
          scrub: 0
        }
      })
    }
  })
}

export default () => {}
